import { useState } from 'react';
import ReactCardFlip from 'react-card-flip';

import ManageCard from './ManageCard';
import CardFront from './CardFront';
import { CardBody } from '../style';

function CardDisplay({ card }) {
  // TODO reset ManageCard state when flipped, ie set interval back to the card's actual value
  const [isFlipped, setFlipped] = useState(false);

  return (
    // TODO put like a gear icon in the corner or something
    // on back side put some sort of identifier for the card ie AMEX  0004
    // TODO break these values into its own style class, since its reused in AddCardButton
    <ReactCardFlip isFlipped={isFlipped} flipDirection='horizontal'>
      <CardFront flip={setFlipped} card={card}></CardFront>
      <ManageCard flip={setFlipped} card={card}></ManageCard>
    </ReactCardFlip>
  );
}

export default CardDisplay;
